module.exports = __webpack_public_path__ + "img/article69.a710f350.jpg";